"use client";

import { css } from "@/../styled-system/css";

import WhiteArrow from "../../../public/WhiteArrow";

const buttonClass = css({
  display: "inline-flex",
  alignItems: "center",
  gap: "4",
  backgroundColor: "brandBlue",
  rounded: "lg",
  cursor: "pointer",
  flexShrink: "0",
  py: "3",
  px: "4",
});

interface ArrowButtonProps {
  content: string;
  link: string;
}

function ArrowButton({ content, link }: ArrowButtonProps) {
  return (
    <button
      className={buttonClass}
      onClick={() => (window.location.href = link)}
    >
      <span className={css({ fontWeight: "semibold", color: "white" })}>
        {content}
      </span>
      <WhiteArrow />
    </button>
  );
}

export default ArrowButton;
